// Module
var code = "<div id=\"cordova.signature-view:close\" class=\"Button-close_Round_Flying-tr\"></div>\n<canvas class=\"sig-Canvas\" id=\"cordova.signature-view:pad\"></canvas>\n";
// Exports
module.exports = code;